// Copyright (c) 2015-present, salesforce.com, inc. All rights reserved

/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@salesforce/design-system-react';
import classNames from 'classnames';
import link from '../../utilities/link';

// ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames)

function HomepageCalendarDay(props) {
  return (
    <div
      className={classNames('homepage-calendar__day slds-p-around--x-small slds-size--1-of-7', {
        'slds-theme--default': props.current,
      })}
    >
      <div className="slds-grid slds-m-bottom--small slds-clearfix">
        <span className="slds-text-title--caps">{props.dayText}</span>
        <span className="slds-text-heading--small slds-container--right">{props.date}</span>
      </div>
      {React.Children.map(props.children, (child, i) => (i < 4 ? child : null))}
      {props.children && props.children.length > 4 ? (
        <div {...link(props.onEllipsisClick)}>
          <Icon
            category="utility"
            className="slds-float--right"
            name="threedots"
            size="small"
            style={{ margin: '-10px 0 -6px', fill: '#CFD4DF' }}
          />
        </div>
      ) : null}
    </div>
  );
}

HomepageCalendarDay.displayName = 'HomepageCalendarDay';

HomepageCalendarDay.propTypes = {
  /**
   * CalendarDay chilren. Typically CalendarItem
   */
  children: PropTypes.node,
  /**
   * Boolean to indicate current (active) day of the week
   */
  current: PropTypes.bool,
  /**
   * Numeric date
   */
  date: PropTypes.number.isRequired,
  /**
   * Text for day of the week: "SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"
   */
  dayText: PropTypes.node.isRequired,
  /**
   * Callback for when ellipsis is clicked. Renderes with Day has more than 4 items
   */
  onEllipsisClick: PropTypes.func,
};

export default HomepageCalendarDay;
